// extracted by mini-css-extract-plugin
export var parcelRow = "_sc-0";